import React from 'react'
import withRedux from 'next-redux-wrapper'
import Theme from 'components/Theme'
import { App, Store } from 'apps/public/artAdvisory'
import { storeSetup } from 'lib/pageSetup'

const title = 'Art Advisory | Saatchi Art'
const description =
  'Work with your own private curator and let them advise you on acquiring art by emerging artists.'
const METADATA = {
  description,
  title,
  og: {
    description,
    image: 'https://d3t95n9c6zzriw.cloudfront.net/art-advisory/hero-lifestyle.jpeg',
    title,
    ttl: '2419200',
    type: 'article',
  },
  preloadImages: [],
  robots: true,
  schema: {
    webpage: {
      headline: title,
      description,
    },
  },
}

const ArtAdvisory = (): React.ReactElement<React.ComponentProps<any>, any> => (
  <Theme>
    <App />
  </Theme>
)

// Always runs (client or server side)
ArtAdvisory.getInitialProps = async ({ store, req }): Record<string, any> => {
  // Client-Side
  if (!req) {
    return {}
  }

  // SSR Logic
  storeSetup(store, req)
  // Metadata & Datalayer
  return {
    dataLayer: {
      event: 'pagetype',
      pagetype: 'ArtAdvisory',
      form_id: 'aa_contact_us_aa_quiz_replace',
      form_name: 'aa services contact us form',
    },
    metaData: METADATA,
  }
}

export default withRedux(Store)(ArtAdvisory)
